import React from "react";
import Navbar from "../components/Navbar";
import { Link } from "react-router-dom";
import { FaFacebook, FaInstagram, FaTiktok, FaWhatsapp } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import NewsletterForm from "../components/NewsletterForm";

const Contact = () => {
  return (
    <main className="pt-24 text-brand-800 route-enter">
      <Navbar />
      {/* Hero header */}
      <section className="bg-gradient-to-br from-brand-900 to-brand-700 text-white">
        <div className="max-w-6xl mx-auto px-6 py-16 grid md:grid-cols-2 gap-8 items-center">
          <div>
            <h1 className="text-4xl md:text-5xl font-extrabold mb-4">Contact Us</h1>
            <p className="text-brand-100 max-w-xl">
              We would love to hear from you. Send a message, email or visit us — we will get back to you shortly.
            </p>
          </div>
          {/* Hero imagery placeholder (user will replace) */}
          <div className="relative">
            <div className="rounded-[2rem] border-4 border-brand-accent bg-white/5 h-64 md:h-80 w-full overflow-hidden">
              <img
                src="/images/contact.png"
                alt="Contact Gesingo Security Technology"
                className="w-full h-full object-cover"
                loading="lazy"
                decoding="async"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Contact information */}
      <section className="max-w-6xl mx-auto px-6 py-12">
        <div className="mb-6">
          <h2 className="text-2xl font-semibold">Contact Information</h2>
          <p className="text-gray-600">Reach us via phone, email or visit our office.</p>
        </div>
        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-6">
          <div className="bg-white rounded-xl shadow p-6">
            <div className="text-brand-600 font-bold text-sm">Phone</div>
            <div className="mt-2 text-lg">(+233) 24 484 4226</div>
            <p className="text-gray-500 text-sm mt-1">Mon–Sun, 7:30am–5:30pm</p>
            <p className="text-gray-500 text-sm mt-1">Closed On Fridays</p>
          </div>
          <div className="bg-white rounded-xl shadow p-6">
            <div className="text-brand-600 font-bold text-sm">Email</div>
            <div className="mt-2 text-lg">gesingosecuritytechnology@gmail.com</div>
            <p className="text-gray-500 text-sm mt-1">We reply within 24 hours</p>
          </div>
          <div className="bg-white rounded-xl shadow p-6">
            <div className="text-brand-600 font-bold text-sm">Location</div>
            <div className="mt-2 text-lg">Oyibi Adamorba Road - Accra </div>
            <p className="text-gray-500 text-sm mt-1">Open Mon–Sun</p>
            <p className="text-gray-500 text-sm mt-1">Closed On Fridays</p>
          </div>
        </div>
      </section>

      {/* Form + Map */}
      <section className="max-w-6xl mx-auto px-6 pb-12 grid md:grid-cols-2 gap-8">
        <div className="bg-gradient-to-b from-brand-900 to-brand-700 text-white rounded-xl p-6 shadow">
          <h3 className="text-xl font-semibold mb-4">Get In Touch!</h3>
          <form
            className="space-y-4"
            action="https://docs.google.com/forms/u/0/d/e/1FAIpQLSfB0IGCqYMslo9NShcxo5TBo4xq8PSTil6KY5QRgKyyo54Qnw/formResponse"
            method="POST"
            target="_blank"
          >
            <input
              name="entry.756152116"
              type="text"
              required
              className="w-full rounded-lg px-4 py-3 bg-white/10 placeholder-brand-100/70 focus:bg-white/20 outline-none"
              placeholder="Full Name"
            />
            <input
              name="entry.899892987"
              type="email"
              required
              className="w-full rounded-lg px-4 py-3 bg-white/10 placeholder-brand-100/70 focus:bg-white/20 outline-none"
              placeholder="Email"
            />
            <input
              name="entry.64415371"
              type="tel"
              className="w-full rounded-lg px-4 py-3 bg-white/10 placeholder-brand-100/70 focus:bg-white/20 outline-none"
              placeholder="Phone number"
            />
            <textarea
              name="entry.324050789"
              rows="4"
              required
              className="w-full rounded-lg px-4 py-3 bg-white/10 placeholder-brand-100/70 focus:bg-white/20 outline-none"
              placeholder="Message"
            />
            <button type="submit" className="inline-flex items-center justify-center px-5 py-3 rounded-full bg-brand-accent text-white font-semibold hover:bg-brand-400 transition">
              Submit
            </button>

          </form>
        </div>
        <div>
          <h3 className="text-xl font-semibold mb-4">Our Location</h3>
            <div className="relative rounded-xl overflow-hidden shadow border border-gray-200">
                <div className="pt-[56.25%]" /> {/* 16:9 spacer */}
              <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3969.2641974507387!2d-0.12480829032236822!3d5.818314130933698!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xfdf7bde799e5f41%3A0x36ef7f7a14e0e316!2sGESINGO%20SECURITY%20TECHNOLOGY!5e0!3m2!1sen!2sgh!4v1773574511120!5m2!1sen!2sgh"
                className="absolute inset-0 w-full h-full border-0"
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Gesingo Security Technology - Map"
                />
            </div>
          <div className="mt-6">
            <h4 className="font-semibold mb-3">Social Media Handles</h4>
            <div className="flex items-center gap-3">
              <a
                  href="https://www.facebook.com/profile.php?id=61558143584321&mibextid=ZbWKwL
"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Facebook"
                  className="w-10 h-10 rounded-lg bg-brand-100 text-brand-700 flex items-center justify-center shadow hover:bg-brand-200"
                  >
                    <FaFacebook className="text-xl" />
                  </a>
                  <a
                    href="https://x.com/gesingo78?t=rEaqqjTk7tLMHksYpFE0YA&s=08"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Twitter/X"
                    className="w-10 h-10 rounded-lg bg-brand-100 text-brand-700 flex items-center justify-center shadow hover:bg-brand-200"
                  >
                    <FaXTwitter className="text-xl" />
                  </a>
                  <a
                    href="https://www.instagram.com/gesingosecurity?igsh=MW81czhseGM5eHFtbg=="
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Instagram"
                    className="w-10 h-10 rounded-lg bg-brand-100 text-brand-700 flex items-center justify-center shadow hover:bg-brand-200"
                  >
                    <FaInstagram className="text-xl" />
                  </a>
                  <a
                    href="https://vm.tiktok.com/ZS9RPPK13FgaD-4OgqD/"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="TikTok"
                    className="w-10 h-10 rounded-lg bg-brand-100 text-brand-700 flex items-center justify-center shadow hover:bg-brand-200"
                  >
                    <FaTiktok className="text-xl" />
                  </a>
                  <a
                    href="https://wa.me/233504869983"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="WhatsApp"
                    className="w-10 h-10 rounded-lg bg-brand-100 text-brand-700 flex items-center justify-center shadow hover:bg-brand-200"
                  >
                    <FaWhatsapp className="text-xl" />
                  </a>
                </div>
            </div>
        </div>
      </section>

      {/* Newsletter */}
      <section className="bg-gradient-to-br from-brand-900 to-brand-800 text-white">
        <div className="max-w-6xl mx-auto px-6 py-12 grid md:grid-cols-[1fr_auto] gap-6 items-center">
          <div>
            <h3 className="text-2xl font-semibold mb-1">Our Newsletters</h3>
            <p className="text-brand-100 max-w-xl">Subscribe to receive updates about our services and initiatives.</p>
          </div>
          <NewsletterForm />
        </div>
      </section>

      {/* Footer imagery placeholder stripe */}
      <section className="bg-brand-50">
        <div className="max-w-6xl mx-auto px-6 py-12 grid md:grid-cols-4 gap-8 bg-white rounded-2xl shadow-sm">
          <div className="space-y-3">
            <img src="/images/logo.png" alt="Gesingo Security Technology logo" className="h-12 w-12 object-contain rounded" />
              <p className="text-gray-600 text-sm">
                  Providing advanced security technology solutions and expert technical services to safeguard your environment.
              </p>
          </div>
          <div className="col-span-3 grid sm:grid-cols-2 gap-6 text-sm text-gray-700">
            <div>
              <div className="font-semibold mb-2">Navigation</div>
              <ul className="space-y-2">
                <li><Link to="/" className="hover:underline">Home</Link></li>
                <li><Link to="/about" className="hover:underline">About</Link></li>
                <li><Link to="/services" className="hover:underline">Services</Link></li>
                <li><Link to="/contact" className="hover:underline">Contact</Link></li>
              </ul>
            </div>
            <div>
              <div className="font-semibold mb-2">Work Hours</div>
              <ul className="space-y-2">
                <li>7AM – 5PM, Mon–Sat</li>
                <li className="text-gray-500">Closed on Sundays</li>
              </ul>
              <div className="mt-4 flex items-center gap-3">
                <a href="tel:+233244844226">
                  <button type="button" className="inline-flex px-4 py-2 rounded-full bg-brand-600 text-white hover:bg-brand-700">Call Us</button>
                </a>
                <a
                  href="https://wa.me/233504869983"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="WhatsApp"
                  className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-brand-500 text-white hover:bg-brand-600 shadow"
                >
                  <FaWhatsapp className="text-lg" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <footer className="text-center text-gray-500 text-sm py-6">
        <p>© {new Date().getFullYear()} Gesingo Security Technology</p>
        <p className="mt-1">Designed by <a href="https://wa.me/233545038856" className="text-brand-600 hover:underline" target="_blank" rel="noopener noreferrer">WASS TECH SOLUTIONS</a></p>
      </footer>
    </main>
  );
};

export default Contact;
